import React from 'react'
import { Button } from 'reactstrap'
import LightbulbIcon from '@mui/icons-material/Lightbulb'
import FeatureVotingDialog from '../FeatureVoting/FeatureVotingDialog'
import { withFirebase } from '../Fb'

function FeatureVotingButton({ firebase, iconOnly }) {
  const [open, setOpen] = React.useState(false)

  const toggle = () => {
    setOpen(!open)
  }

  return (
    <>
      <FeatureVotingDialog firebase={firebase} toggle={toggle} isOpen={open} />
      <Button size='sm' onClick={() => toggle()} style={{ marginRight: 10 }} title={iconOnly ? 'Ominaisuustoiveet' : undefined}>
        <LightbulbIcon fontSize='small' />{iconOnly ? '' : ' Ominaisuustoiveet'}
      </Button>
    </>
  )
}

export default withFirebase(FeatureVotingButton)
